import { connect, ConnectedProps } from "react-redux";
import { withRouter } from "react-router";
import { TripCategory } from "redmond";
import { BookingSuccessModal } from "./component";
import {
  getEarnedString,
  getFinalizedItinerary,
  getFinalizedCallState,
  getConfirmationEmail,
  getPriceDropProperties,
  getUserSelectedTravelersList,
  getUserSelectedPassengerIds,
  getUserPassengers,
  getSelectedOnlyNonVXCardPayment,
  hasAddOnBeenAttachedSelector,
  getOfferToApply,
} from "../../reducer";
import { IStoreState } from "../../../../reducers/types";
import { redoSearch, chargeAgentBookingFee } from "../../actions/actions";
import {
  airportsSelector,
  selectedTripSelector,
  tripDetailsSelector,
  predictionSelector,
  selectedDisruptionProtectionOfferProductVariantSelector,
  fetchAncillaryOfferRequestParametersSelector,
} from "../../../shop/reducer/selectors";
import {
  getHasUserSetFlightPreferences,
  getTripCategory,
  getUserFlightPreferencesCallState,
} from "../../../search/reducer";
import {
  getHotelAvailabilityFromDate,
  getAvailableCrossSellHotels,
  getHotelAvailabilitySearchLocationResult,
  getHotelAvailabilityUntilDate,
  getPotentialCrossSellOffers,
  getHotelAvailabilityNextPageToken,
} from "../../../cross-sell/reducer/selectors";
import { fetchMoreCrossSellHotelAvailability } from "../../../cross-sell/actions/actions";
import { getBookingConfirmation, getDpProductVariant } from "./bookingConfirmationStorage";
import { fetchCfarPostBookingOffer } from "../../../ancillary/actions/actions";
import { cfarPostBookingOfferStateSelector } from "../../../ancillary/reducer/selectors/postBooking";
import { isPostBookingCfarEnabledSelector } from "../../../ancillary/reducer/selectors";

const mapStateToProps = (state: IStoreState) => {
  const reduxItinerary = getFinalizedItinerary(state);
  const reduxTripDetails = tripDetailsSelector(
    state,
    selectedTripSelector(state)?.tripId || ""
  );

  // Fall back to sessionStorage if Redux state is empty (e.g., after page refresh)
  const savedConfirmation =
    !reduxItinerary || !reduxTripDetails ? getBookingConfirmation() : null;

  const reduxProductVariant =
    selectedDisruptionProtectionOfferProductVariantSelector(state);

  return {
    itinerary: reduxItinerary ?? savedConfirmation?.itinerary,
    finalizedCallState: getFinalizedCallState(state),
    airports: airportsSelector(
      state,
      selectedTripSelector(state)?.tripId || ""
    ),
    tripDetails: reduxTripDetails ?? savedConfirmation?.tripDetails,
    isRoundTrip: getTripCategory(state) === TripCategory.ROUND_TRIP,
    earnString: getEarnedString(state),
    confirmationEmail: getConfirmationEmail(state),
    prediction: predictionSelector(state),
    priceDropViewedProperties: getPriceDropProperties(state),
    lodgings: getAvailableCrossSellHotels(state),
    hasUserSetFlightPreferences: getHasUserSetFlightPreferences(state),
    userFlightPreferencesCallState: getUserFlightPreferencesCallState(state),
    potentialCrossSellOffers: getPotentialCrossSellOffers(state),
    searchLocationResult: getHotelAvailabilitySearchLocationResult(state),
    fromDate: getHotelAvailabilityFromDate(state),
    untilDate: getHotelAvailabilityUntilDate(state),
    nextPageToken: getHotelAvailabilityNextPageToken(state),
    selectedTravelersList: getUserSelectedTravelersList(state),
    selectedTravelersIds: getUserSelectedPassengerIds(state),
    userPassengers: getUserPassengers(state),
    selectedOnlyNonVXCardPayment: getSelectedOnlyNonVXCardPayment(state),
    hasFintechAttached: hasAddOnBeenAttachedSelector(state),
    offerToApply: getOfferToApply(state),
    productVariant: reduxProductVariant ?? getDpProductVariant(),
    cfarPostBookingOfferState: cfarPostBookingOfferStateSelector(state),
    isPostBookingCfarEnabled: isPostBookingCfarEnabledSelector(state),
    fetchAncillaryOfferRequest: fetchAncillaryOfferRequestParametersSelector(state),
  };
};

const mapDispatchToProps = {
  chargeAgentBookingFee,
  redoSearch,
  fetchMoreCrossSellHotelAvailability,
  fetchCfarPostBookingOffer,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type BookingSuccessModalConnectorProps = ConnectedProps<
  typeof connector
>;

export const ConnectedBookingSuccessModal = withRouter(
  connector(BookingSuccessModal)
);
